import { InputTableURLsTable } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { RowData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import BasePaymentMethodInfoTPV from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/BasePaymentMethodInfoTPV'
import { SetEditDeleteModalTy } from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalPaymentMethodInfoSellTicketRefundProps {
    setOpenModal: SetEditDeleteModalTy
    handleCloseModal?: () => void
    allRowData?: RowData
    inputTableURLs: InputTableURLsTable
    isReservedRefund?: boolean
}

const ModalPaymentMethodInfoSellTicketRefund: React.FC<ModalPaymentMethodInfoSellTicketRefundProps> = ({ setOpenModal, allRowData, handleCloseModal, inputTableURLs, isReservedRefund }) => {
    const { t } = useTwinTranslation()
    return (
        <BasePaymentMethodInfoTPV {...{
            setOpenModal, allRowData, inputTableURLs, isReservedRefund, translations: { title: t('refundDone', 'Devolución realizada'), textButton: { send: t('senRefund', 'Enviar devolución'), gift: '', print: t('printRefund', 'Imprimir devolución') }, numOrderTitle: t('nRefund', 'Núm. Devolución') }, handleCloseModal, functionButtonsURLs: {
                send: '/api/app/order/tpv/sellTicketRefund/sendSellTicketRefundPDF', gift: '', print: '/api/app/order/tpv/sellTicketRefund/getPrintSellTicketRefund'
        } }} />
    )
}

export default ModalPaymentMethodInfoSellTicketRefund